import { render, staticRenderFns } from "./toBeEdited.vue?vue&type=template&id=4a053982&scoped=true"
import script from "./toBeEdited.vue?vue&type=script&lang=js"
export * from "./toBeEdited.vue?vue&type=script&lang=js"
import style0 from "./toBeEdited.vue?vue&type=style&index=0&id=4a053982&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a053982",
  null
  
)

export default component.exports